/**
 * Domain → client (tenant) mapping.
 * Her domain kendi clientId altındaki Firestore/Storage path'lerini kullanır.
 *
 * dogandemir.lexivo.org → documents/dogandemir/documents, requests/dogandemir/requests, templates/dogandemir/templates
 * hergulkir.lexivo.org  → documents/hergulkir/documents, requests/hergulkir/requests, templates/hergulkir/templates
 * Diğer (test, staging vb.) → default client (REACT_APP_DEFAULT_CLIENT_ID veya 'hergulkir')
 */

const DOMAIN_CLIENT_MAP = {
  'dogandemir.lexivo.org': 'dogandemir',
  'hergulkir.lexivo.org': 'hergulkir',
};

const DEFAULT_CLIENT_ID =
  (typeof process !== 'undefined' &&
    process.env &&
    process.env.REACT_APP_DEFAULT_CLIENT_ID) ||
  'hergulkir';

/**
 * Mevcut hostname'e göre clientId döner.
 * Tarayıcı dışında (build/test) çağrılırsa DEFAULT_CLIENT_ID kullanılır.
 */
export function getClientId() {
  if (typeof window === 'undefined' || !window.location) {
    return DEFAULT_CLIENT_ID;
  }
  const hostname = window.location.hostname;
  return DOMAIN_CLIENT_MAP[hostname] ?? DEFAULT_CLIENT_ID;
}

/**
 * Storage path prefix'leri (client bazlı)
 */
export function getDocumentsStoragePrefix() {
  return `documents/${getClientId()}/documents`;
}

export function getRequestsStoragePrefix() {
  return `requests/${getClientId()}`;
}

export function getTemplatesStoragePrefix() {
  return `templates/${getClientId()}`;
}

export { DOMAIN_CLIENT_MAP, DEFAULT_CLIENT_ID };
